// @flow
import { useJsonForms } from '@jsonforms/react';

import { getLayoutProps } from '../util/useLayoutProps';

type Options = {
    uischema: $FixMe,
    schema: $FixMe,
    path: string
};

const useGetVisibleTabProps = ({
    uischema,
    schema,
    path
}: Options): Array<$FixMe> => {
    const ctx = useJsonForms();

    return uischema.elements
        .map(element => {
            return getLayoutProps(ctx, {
                uischema: element,
                schema,
                path
            });
        })
        .filter(({ visible }) => visible);
};

export default useGetVisibleTabProps;
